import classNames from 'classnames'
import React from 'react'
import { useSearchParams } from 'react-router-dom'

import { parseOptionsQuery } from '../utils/query'

export default function ViewFooter({ className }: { className?: string }) {
  const [searchParams] = useSearchParams()
  const { ticker, expiry, strike } = parseOptionsQuery(searchParams)

  const exportUrl = React.useMemo(
    () =>
      'export/options?' +
      new URLSearchParams({
        t: ticker,
        e: expiry ?? '',
        s: strike ? strike.toString() : '',
      }),
    [ticker, expiry, strike]
  )

  return (
    <div className={classNames('flex justify-between text-2xs text-muted-2', className)}>
      Options delayed 15 minutes
      <a
        href={exportUrl}
        className="tab-link"
        onClick={() => {
          window.gtag && window.gtag('event', 'download', { event_category: 'export' })
        }}
      >
        export
      </a>
    </div>
  )
}
